import React from "react";
import { Link } from "react-router-dom";
import { PageHeadingContainer } from "./PageHeading.style";

const PageHeading = ({ title, breadcrumbs = [] }) => {
    return (
        <PageHeadingContainer>
            <div className="pageheading_section">
                <div className="mygrid-container">
                    <div className="mygrid-row">
                        <div className="mygrid-col-md-12">
                            {/* Breadcrumbs */}
                            {breadcrumbs.length > 0 && (
                                <nav className="breadcrumb_page_heading">
                                    {breadcrumbs.map((crumb, index) => (
                                        <span key={index}>
                                            {crumb.path ? (
                                                <Link to={crumb.path} className="hover:underline">
                                                    {crumb.label}
                                                </Link>
                                            ) : (
                                                <span>{crumb.label}</span>
                                            )}
                                            {index < breadcrumbs.length - 1 && " > "}
                                        </span>
                                    ))}
                                </nav>
                            )}
                            {/* Page Title */}
                            <h1 className="page_heading_h1">{title}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </PageHeadingContainer>
    );
};

export default PageHeading;
